module.exports = __webpack_public_path__ + "static/media/logo-padilla-solo.202298eb.svg";